import ComboBox from "sap/m/ComboBox";
import { MetadataOptions } from "sap/ui/base/ManagedObject";
import {
  ManyOptionsComboBoxMetadata,
  ManyOptionsComboBoxFilterOptions,
  ManyOptionsComboBoxUpdateItems,
} from "../utils/ManyOptionsComboBoxUtil";

/**
 * @namespace akademika.akamont.customControls
 */
export default class ManyOptionsComboBox extends ComboBox {
  static readonly metadata: MetadataOptions = ManyOptionsComboBoxMetadata;

  static renderer = { apiVersion: 2 };

  updateItems(sReason: string) {
    // @ts-expect-error Method "updateItems" exists, but isn't exposed through the type
    super.updateItems.apply(this, [sReason]);

    ManyOptionsComboBoxUpdateItems(this, sReason);
  }

  public oninput(oEvent: unknown) {
    ManyOptionsComboBoxFilterOptions(this);
    // @ts-expect-error Method "ComboBox.oninput" exists, but isn't exposed through the type
    super.oninput(oEvent);
  }
}
